import { FullscreenExitOutlined } from '@ant-design/icons'
import SimilarityOrder from './SimilarityOrder'
import DynastyOrder from './DynastyOrder'
import { similarImgsInfoI } from '..'
import { useState } from 'react'

export interface similarImgsInfoDynastyI {
  先秦: similarImgsInfoI[]
  魏晋南北朝: similarImgsInfoI[]
  隋唐: similarImgsInfoI[]
  五代十国: similarImgsInfoI[]
  宋代: similarImgsInfoI[]
  元代: similarImgsInfoI[]
  明代: similarImgsInfoI[]
  清代: similarImgsInfoI[]
  近现代: similarImgsInfoI[]
  未知: similarImgsInfoI[]
}

const Chuanyi = (props) => {
  const setShowPanel = props.setShowPanel
  const similarImgsInfo = props.similarImgsInfo
  const similarImgsInfo_sortByDynasty: similarImgsInfoDynastyI = {
    先秦: [],
    魏晋南北朝: [],
    隋唐: [],
    五代十国: [],
    宋代: [],
    元代: [],
    明代: [],
    清代: [],
    近现代: [],
    未知: []
  }
  for (let i = 0; i < similarImgsInfo.length; i++) {
    similarImgsInfo_sortByDynasty[similarImgsInfo[i].dynasty]?.push(similarImgsInfo[i])
  }
  const [order, setOrder] = useState<number>(0) //0:按朝代排序；1:按相似度排序
  return (
    <div className='chuanyi-panel'>
      <div className='chuanyi-title'>
        <h2>传移模写</h2>
        <div className='chuanyi-control'>
          <button
            className={
              order === 0 ? 'chuanyi-control-button-select' : 'chuanyi-control-button-unselect'
            }
            onClick={() => {
              setOrder(0)
            }}
          >
            朝代
          </button>
          <button
            className={
              order === 1 ? 'chuanyi-control-button-select' : 'chuanyi-control-button-unselect'
            }
            onClick={() => {
              setOrder(1)
            }}
          >
            相似度
          </button>
          <FullscreenExitOutlined
            className='chuanyi-control-exitFullscreen'
            onClick={() => {
              setShowPanel(0)
            }}
          />
        </div>
      </div>
      {order === 0 ? (
        <DynastyOrder similarImgsInfo={similarImgsInfo_sortByDynasty} />
      ) : (
        <SimilarityOrder similarImgsInfo={similarImgsInfo} />
      )}
    </div>
  )
}

export default Chuanyi
